import React from 'react';

export function SubrivaLogo({ size = 36, className = '' }) {
  return (
    <img
      src="/logo.png"
      alt="Subriva HR & Payroll"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain', display: 'block' }}
    />
  );
}

export default SubrivaLogo;
